import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
  apiCallFailed,
  apiCallSuccess,
} from '../../store/actions/notification';
import { LandingComponent } from './Landing';
import styles from './styles';

const mapStatetoProps = state => ({
  notification: state.notification,
});

const mapDispatchToProps = dispatch => ({
  dispatchApiCallFailed: () => dispatch(apiCallFailed()),
  dispatchApiCallSuccess: () => dispatch(apiCallSuccess()),
});

export default withStyles(styles)(
  connect(
    mapStatetoProps,
    mapDispatchToProps,
  )(LandingComponent),
);
